var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('p',{staticClass:"page-subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }